export interface WarehousingItemDimensions {
  lengthUnitName?: string;
  lengthMeters?: number;
  breadthMeters?: number;
  heightMeters?: number;
  sqm?: number;
  cbm?: number;
}

export function itemSizeLabel(item?: WarehousingItemDimensions | null): string {
  if (!item) {
    return '';
  }
  if (hasDimension(item.lengthMeters) && hasDimension(item.breadthMeters) && hasDimension(item.heightMeters)) {
    const unit = item.lengthUnitName?.trim() || 'm';
    return `${formatDimension(item.lengthMeters)} x ${formatDimension(item.breadthMeters)} x ${formatDimension(item.heightMeters)} ${unit}`;
  }
  return [
    hasDimension(item.sqm) && item.sqm > 0 ? `SQM ${formatDimension(item.sqm)} m²` : '',
    hasDimension(item.cbm) && item.cbm > 0 ? `CBM ${formatDimension(item.cbm)} m³` : ''
  ].filter(Boolean).join(' | ');
}

export function itemIdentityLabel(
  item?: (WarehousingItemDimensions & { itemNumber?: string; itemName?: string }) | null,
  fallback = '-'
): string {
  const identity = [item?.itemNumber, item?.itemName].filter(Boolean).join(' ').trim() || fallback;
  const size = itemSizeLabel(item);
  return size ? `${identity} | ${size}` : identity;
}

function hasDimension(value: number | undefined): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

function formatDimension(value: number): string {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 4, useGrouping: false }).format(value);
}
